import lightDismissible from './src/light-dismissible/light-dismissible';
import toolbarTemplate from './src/template/toolbar-template.pug';
import { getAccountInformationView } from './src/account-information-view/account-information-view';
import { getBidCapView } from './src/bid-cap-view/bid-cap-view';
import { getBidStrategyView } from './src/bid-strategy-view/bid-strategy-view';
import { getBidMultipliersView } from './src/bid-multipliers-view/bid-multipliers-view';
import { getProjectionGridDateFilter } from './src/date-filter/projection-grid-date-filter';
import { DropdownSearchSelector } from './src/dropdown-search-selector/dropdown-search-selector';
import { getEditPanelView } from './src/edit-panel-view/edit-panel-view';
import { getFetchPreferenceConfig } from './src/service/fetch-preference-config';
import { getHotelGroupInformationView } from './src/hotel-group-information-view/information-view';
import { getHotelGroupModel } from './src/hotel-group-model/hotel-group-model';
import { getHotelModel } from './src/hotel-model/hotel-model';
import { getInstrumentation } from './src/instrumentation/index';
import { getEdmBhc } from './src/js-data-bhc/edm-bhc';
import { getUserCountryService } from './src/bid-multipliers-view/user-country/user-country-service';
import { getSubAccountModel } from './src/sub-account-model/sub-account-model';

export const getHotelCenterShared = ({
  pageContext, i18n, state, config, preferencesService, CustomerIdType,
  segmentationPreferences, jsdata, edm, dateFilterPreferences,
  fixedBidSchema, percentageBidSchema, payPerStayBidSchema, multiplierSchema,
  hotelGroupSchema, hotelSchema, subAccountSchema, schemas,
} = {}) => ({
  DropdownSearchSelector,
  lightDismissible,
  toolbarTemplate,
  ...getAccountInformationView({ i18n }),
  ...getBidCapView({ i18n, config, fixedBidSchema }),
  ...getBidStrategyView({
    i18n, pageContext, config, fixedBidSchema, percentageBidSchema, payPerStayBidSchema,
  }),
  ...getBidMultipliersView({
    i18n, state, pageContext, multiplierSchema,
  }),
  ...getProjectionGridDateFilter({
    i18n, pageContext, state, dateFilterPreferences,
  }),
  ...getEditPanelView({ i18n }),
  ...getFetchPreferenceConfig({ state, preferencesService, segmentationPreferences }),
  ...getHotelGroupInformationView({ i18n }),
  ...getHotelGroupModel({
    i18n, hotelGroupSchema, state, jsdata, edm,
  }),
  ...getHotelModel({
    i18n, hotelSchema, jsdata, edm, state,
  }),
  ...getInstrumentation({ pageContext, config }),
  ...getEdmBhc({
    state, schemas, config, CustomerIdType,
  }),
  ...getUserCountryService({ state, i18n }),
  ...getSubAccountModel({
    state, i18n, subAccountSchema, jsdata, edm,
  }),
});
